import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    name: 'Mariana L.',
    role: 'Jefa de RRHH Clínica Privada',
    location: 'Córdoba',
    text: '¡Me salvó la vida! Antes armar los turnos de guardia era un dolor de cabeza. Ahora con el planificador tengo todo resuelto en minutos y sin errores.'
  }, {
    name: 'Javier S.',
    role: 'Director Administrativo',
    location: 'CABA',
    text: 'Excelente material. Pasamos la última inspección del Ministerio sin problemas gracias al control de habilitaciones y matrículas. Muy recomendado.'
  }, {
    name: 'Valeria M.',
    role: 'Coordinadora Médica',
    location: 'Rosario',
    text: 'Como encargada en un sanatorio chico, esto es oro. Las fichas de personal y el dashboard me ahorran horas de trabajo todas las semanas.'
  }, {
    name: 'Diego F.',
    role: 'Gerente de Operaciones',
    location: 'Mendoza',
    text: 'Súper completo y fácil de adaptar a nuestra realidad. El liquidador de adicionales nos solucionó un problema enorme con el sindicato.'
  }];
  return <section className="py-12 px-4" data-id="element-158">
      <div className="max-w-lg mx-auto" data-id="element-159">
        <h2 className="text-2xl font-bold text-center text-white mb-8 drop-shadow-lg" data-id="element-160">
          Lo que dicen nuestros colegas
        </h2>

        <div className="grid gap-4" data-id="element-161">
          {reviews.map((review, idx) => <div key={idx} className="bg-white/95 backdrop-blur-sm p-5 rounded-xl border border-white/40 shadow-lg" data-id="element-162">
              <div className="flex gap-1 mb-3" data-id="element-163">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-164" />)}
              </div>
              <p className="text-slate-700 italic mb-4 text-sm leading-relaxed" data-id="element-165">
                "{review.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-166">
                <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center text-teal-700 font-bold" data-id="element-167">
                  {review.name.charAt(0)}
                </div>
                <div data-id="element-168">
                  <p className="font-bold text-slate-900 text-sm" data-id="element-169">
                    {review.name}
                  </p>
                  <p className="text-xs text-slate-500" data-id="element-170">
                    {review.role} • {review.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}